// extracted by css-extract-rspack-plugin
export default {"container":"rrOxYClb7FEB3Nbc","comment":"xcfTgLz0PvodkT46","title":"qIlPNkE9WL8O1oZl"};